/**
 * Section 1: Instructions and Property Address
 */

import { useAuth } from '@ox/visits-ui/context/AuthContext';
import { useForm } from '@ox/visits-ui/context/FormContext';

export function Section1Instructions() {
  const { userData } = useAuth();
  const { draft } = useForm();
  const visitType = draft?.visitType || 'Pre-Walk';

  return (
    <div className="form-section">
      <h2>Property Information</h2>

      <div className="property-info-wrapper">
        <div className="property-label">Property Address</div>
        <div className="property-value-display">
          {userData?.property_address || 'Loading address...'}
        </div>
      </div>

      <hr className="section-divider" />

      <h2>Instructions</h2>
      <p>
        If there are ANY questions about the initial walkthrough or use of this form, please call or
        text <strong>1-469-949-3347</strong>.
      </p>

      <h3>Important Notes:</h3>
      <ul>
        <li>
          Please take all photos {visitType === 'Pre-Walk' ? 'and videos ' : ''}with your phone in <strong>landscape mode</strong>
        </li>
        <li>For best photo quality, please ensure all interior room photos are photographed from floor to ceiling</li>
        {visitType === 'Pre-Walk' && <li>Film your video prior to uploading (do not record in-form)</li>}
        <li>Ensure good lighting for all photos{visitType === 'Pre-Walk' ? ' and videos' : ''}</li>
        <li>Form automatically saves your progress</li>
      </ul>

      <p>Click "Continue" to begin the walkthrough form.</p>
    </div>
  );
}
